const React = require('react');
const withState = require('../../../../../../../../utils/withState');
const noop = require("mn-utils/noop");
const changeProviderProvider = require("mn-utils/changeProviderProvider");
const handleProviderProvider = require("mn-utils/changeProviderProviderSimple");
const map = require("mn-utils/map");
const trim = require("mn-utils/trim");
const isASCII = require("mn-utils/isASCII");
const TextField = require("../../../../../../../dumb/TextField/A");
const Button = require("../../../../../../../dumb/Button/C");
const SubmitButton = require("../../../../../../../dumb/Button/Accept");
const Switch = require("../../../../../../../dumb/Switch/C");
const Select = require("../../../../../../../dumb/Select/H");
const validateUrl = require("../../../../../../../../utils/validateUrl");
const {openPopupInfo} = require("../../../../../../../../emitters/popup");
const DeleteIcon = require("@material-ui/icons/Delete").default;
const AddCircleOutlineIcon = require("@material-ui/icons/AddCircleOutline").default;

module.exports = withState((setState, self) => {
  const ENGINES_LIST = [
    {id: 'woocommerce', name: 'WooCommerce (Wordpress)'},
    {id: 'shopify', name: 'Shopify'},
    {id: 'presta_shop', name: 'Presta Shop'},
    {id: 'magento', name: 'Magento'},
    {id: 'magento_2', name: 'Magento 2'},
    {id: 'shopware_5', name: 'Shopware 5'},
    {id: 'shopware_6', name: 'Shopware 6'},
    {id: 'salesforce', name: 'Salesforce'}
  ];

  const data = self.props.data || {};

  self.state = {
    clicked: false,
    websites: data.website ? [data.website] : [''],
    isPlugin: !!data.engine,
    engine: data.engine || ENGINES_LIST[0].id,
    note: data.note
  };

  const changeProvider = changeProviderProvider(setState);
  const handleProvider = handleProviderProvider(setState);

  const handleChangeEngine = handleProvider('engine');
  const handleChangeNote = changeProvider('note');

  return (state, props) => {

    const clicked = state.clicked;
    const websites = state.websites || [];
    const isPlugin = state.isPlugin || '';
    const engine = state.engine || ENGINES_LIST[0].id;
    const note = state.note || '';

    const disableWebsiteArr = !!data.website;

    const disabled = !!websites.some((el) => (!el || !validateUrl(trim(el))));

    const submitFN = () => {
      setState({clicked: true, loading: true});

      if (disabled) {
        setState({loading: false});
        return;
      }

      const {onSubmit, onUpdate = noop, onClose = noop, finalMessage = []} = props;

      if (!onSubmit) return;

      onSubmit({
        websites,
        engine: isPlugin ? engine : 'api',
        note
      }).then(() => {
        onUpdate();
        onClose();

        if (finalMessage.length) openPopupInfo([finalMessage]);
      })
    }


    return (
      <>
        <div className="layoutRow aiC">
          <div className="f23 fw7 lh wmin0">
            {props.title || ''}
          </div>
          <Switch
            className="ml20"
            label="Widget Is Plugin"
            checked={isPlugin}
            onChange={() => setState({isPlugin: !isPlugin})}
          />
        </div>
        {isPlugin && (
          <>
            <div className="mt20 f15 fw5">Plugin CMS *</div>
            <div className="mt20">
              <Select
                className="f12 lh17 fw7"
                propName="name"
                propValue="id"
                value={engine}
                items={ENGINES_LIST}
                onChange={handleChangeEngine}
              />
            </div>
          </>
        )}
        <div className="mt20 f15 fw5">Websites *</div>
        <div className="mt20">
          {map(websites, (website, i) => {

            const onChange = (e) => {
              const _websites = [...websites];
              _websites[i] = e.target.value;
              setState({
                websites: _websites,
              });
            };

            const _website = trim(website);
            const invalidWebsite = !_website || !validateUrl(_website);

            return (
              <div
                key={i}
                className="layoutRow fhaS fvaC bs bcF2 b bt1
                      (bt|pt):first pb:last pv10"
              >
                <div className="w">
                  <TextField
                    placeholder="Website"
                    value={website}
                    onChange={onChange}
                    error={clicked && invalidWebsite}
                  />
                </div>
                {!disableWebsiteArr && (
                  <div className="pl10">
                    <Button
                      onClick={() => {
                        const _websites = [...websites];
                        _websites.splice(i, 1);
                        setState({
                          websites: _websites,
                        });
                      }}
                      disabled={websites.length <= 1 || disableWebsiteArr}
                    >
                      <DeleteIcon/>
                    </Button>
                  </div>
                )}
              </div>

            )
          })}
        </div>
        {!disableWebsiteArr && (
          <div className="mt20">
            <Button
              onClick={() => {
                setState({
                  websites: [
                    ...websites,
                    '',
                  ],
                });
              }}
            >
              <AddCircleOutlineIcon/>
              <div className="pl10">Add</div>
            </Button>
          </div>
        )}
        {/*<div className="mt20">*/}
        {/*  <TextField*/}
        {/*    className="mt30 h140>textarea"*/}
        {/*    placeholder="Notes"*/}
        {/*    value={note}*/}
        {/*    onChange={handleChangeNote}*/}
        {/*    maxLength={15000}*/}
        {/*    withCount*/}
        {/*    multiline*/}
        {/*  />*/}
        {/*</div>*/}
        <div className="mt30 layoutRow fhaS fvaC">
          <SubmitButton
            disabled={clicked && disabled}
            onClick={submitFN}
          >{props.submitBtnText}</SubmitButton>
        </div>
      </>
    )
  }
})
